import {Component, Input} from '@angular/core';
import {IImage} from '@services/resource/iimage';
import {MarkantElementsModule} from '@markant/elements-angular';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-media-list-published',
  templateUrl: './media-list-published.component.html',
  styleUrls: ['./media-list-published.component.scss'],
  standalone: true,
  imports: [CommonModule, MarkantElementsModule],
})
export class MediaListPublishedComponent {
  @Input() images: IImage[];
  @Input() fullPage = false;
  imageUrls: (string | null)[];
  dialogState = false;
  pickedUrl: string | null = null;

  openModal(url: string) {
    this.dialogState = true;
    this.pickedUrl = url;
    this.imageUrls = this.images.map((image) => image.url);
  }

  closeModal() {
    this.dialogState = false;
    this.pickedUrl = null;
  }

  before() {
    if (this.indexOfCurrentUrl === 0) {
      this.pickedUrl = this.imageUrls[this.imageUrls.length - 1];
    } else {
      this.pickedUrl = this.imageUrls[this.indexOfCurrentUrl - 1];
    }
  }

  next() {
    if (this.indexOfCurrentUrl === this.imageUrls.length - 1) {
      this.pickedUrl = this.imageUrls[0];
    } else {
      this.pickedUrl = this.imageUrls[this.indexOfCurrentUrl + 1];
    }
  }

  get indexOfCurrentUrl() {
    return this.imageUrls.indexOf(this.pickedUrl);
  }
}
